import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b5a2575"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.7071 5.29289C13.0976 5.68342 13.0976 6.31658 12.7071 6.70711L9.41421 10L12.7071 13.2929C13.0976 13.6834 13.0976 14.3166 12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289L11.2929 5.29289C11.6834 4.90237 12.3166 4.90237 12.7071 5.29289Z",
    fill: "white"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "dw-sidebar__container"
}
const _hoisted_4 = { class: "container__header" }
const _hoisted_5 = { class: "container__content" }
const _hoisted_6 = {
  key: 0,
  class: "content__loader"
}
const _hoisted_7 = {
  key: 1,
  class: "dw-sidebar__vertical-tabs"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13 16V6C13 5.44772 12.5523 5 12 5H4C3.44772 5 3 5.44772 3 6V16C3 16.5523 3.44772 17 4 17H5M13 16C13 16.5523 12.5523 17 12 17H9M13 16L13 8C13 7.44772 13.4477 7 14 7H16.5858C16.851 7 17.1054 7.10536 17.2929 7.29289L20.7071 10.7071C20.8946 10.8946 21 11.149 21 11.4142V16C21 16.5523 20.5523 17 20 17H19M13 16C13 16.5523 13.4477 17 14 17H15M5 17C5 18.1046 5.89543 19 7 19C8.10457 19 9 18.1046 9 17M5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17M15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17M15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17",
    stroke: "currentColor",
    "stroke-width": "1.5"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 512 512",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M491.729,112.971L259.261,0.745c-2.061-0.994-4.461-0.994-6.521,0L20.271,112.971c-2.592,1.251-4.239,3.876-4.239,6.754    v272.549c0,2.878,1.647,5.503,4.239,6.754l232.468,112.226c1.03,0.497,2.146,0.746,3.261,0.746s2.23-0.249,3.261-0.746    l232.468-112.226c2.592-1.251,4.239-3.876,4.239-6.754V119.726C495.968,116.846,494.32,114.223,491.729,112.971z M256,15.828    l215.217,103.897l-62.387,30.118c-0.395-0.301-0.812-0.579-1.27-0.8L193.805,45.853L256,15.828z M176.867,54.333l214.904,103.746    l-44.015,21.249L132.941,75.624L176.867,54.333z M396.799,172.307v78.546l-41.113,19.848v-78.546L396.799,172.307z     M480.968,387.568L263.5,492.55V236.658l51.873-25.042c3.73-1.801,5.294-6.284,3.493-10.015    c-1.801-3.729-6.284-5.295-10.015-3.493L256,223.623l-20.796-10.04c-3.731-1.803-8.214-0.237-10.015,3.493    c-1.801,3.73-0.237,8.214,3.493,10.015l19.818,9.567V492.55L31.032,387.566V131.674l165.6,79.945    c1.051,0.508,2.162,0.748,3.255,0.748c2.788,0,5.466-1.562,6.759-4.241c1.801-3.73,0.237-8.214-3.493-10.015l-162.37-78.386    l74.505-35.968L340.582,192.52c0.033,0.046,0.07,0.087,0.104,0.132v89.999c0,2.581,1.327,4.98,3.513,6.353    c1.214,0.762,2.599,1.147,3.988,1.147c1.112,0,2.227-0.247,3.26-0.746l56.113-27.089c2.592-1.251,4.239-3.875,4.239-6.754v-90.495    l69.169-33.392V387.568z"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_sidebar_tabs = _resolveComponent("dw-sidebar-tabs")!
  const _component_dw_loader = _resolveComponent("dw-loader")!
  const _component_dw_sidebar_couriers = _resolveComponent("dw-sidebar-couriers")!
  const _component_dw_sidebar_orders = _resolveComponent("dw-sidebar-orders")!
  const _component_dw_sidebar_problems = _resolveComponent("dw-sidebar-problems")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["dw-sidebar", { 'dw-sidebar--opened': _ctx.state.is_opened }])
  }, [
    _createElementVNode("div", {
      class: "dw-sidebar__toggle",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, _hoisted_2),
    (_ctx.state.is_opened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_dw_sidebar_tabs, {
              tabs: _ctx.tabs,
              value: _ctx.activeTab,
              onChange: _ctx.onTabChange
            }, null, 8, ["tabs", "value", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_dw_loader)
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.activeTab === _ctx.DW_CONSTANTS.COURIERS_TAB.id)
                    ? (_openBlock(), _createBlock(_component_dw_sidebar_couriers, {
                        key: 0,
                        couriers: _ctx.couriers,
                        "showed-routes-couriers-ids": _ctx.showedRoutesCouriersIds,
                        "is-completed-orders-enabled": _ctx.isCouriersCompletedOrdersEnabled,
                        "is-problems-enabled": _ctx.isCouriersProblemsEnabled,
                        "is-deliveries-enabled": _ctx.isCouriersDeliveriesEnabled,
                        "is-undelivered-deliveries-enabled": _ctx.isCouriersUndeliveredDeliveriesEnabled,
                        "is-takes-enabled": _ctx.isCouriersTakesEnabled,
                        "is-unassigned-takes-enabled": _ctx.isCouriersUnassignedTakesEnabled,
                        "selected-sidebar-feature-id": _ctx.selectedSidebarFeatureId,
                        onShowRoute: _ctx.onShowCourierRoute,
                        onEntityClicked: _ctx.onCourierEntityClicked
                      }, null, 8, ["couriers", "showed-routes-couriers-ids", "is-completed-orders-enabled", "is-problems-enabled", "is-deliveries-enabled", "is-undelivered-deliveries-enabled", "is-takes-enabled", "is-unassigned-takes-enabled", "selected-sidebar-feature-id", "onShowRoute", "onEntityClicked"]))
                    : (_ctx.activeTab === _ctx.DW_CONSTANTS.ORDERS_TAB.id)
                      ? (_openBlock(), _createBlock(_component_dw_sidebar_orders, {
                          key: 1,
                          entities: _ctx.items,
                          "is-completed-orders-enabled": _ctx.isOrdersCompletedOrdersEnabled,
                          "is-deliveries-enabled": _ctx.isOrdersDeliveriesEnabled,
                          "is-undelivered-deliveries-enabled": _ctx.isOrdersUndeliveredDeliveriesEnabled,
                          "is-takes-enabled": _ctx.isOrdersTakesEnabled,
                          "is-unassigned-takes-enabled": _ctx.isOrdersUnassignedTakesEnabled,
                          "selected-unassigned-takes": _ctx.selectedUnassignedTakes,
                          "selected-sidebar-feature-id": _ctx.selectedSidebarFeatureId,
                          onEntityClicked: _ctx.onOrderEntityClicked,
                          onToggleUnassignedTake: _ctx.toggleUnassignedTake,
                          onMassAppointment: _ctx.onMassAppointment
                        }, null, 8, ["entities", "is-completed-orders-enabled", "is-deliveries-enabled", "is-undelivered-deliveries-enabled", "is-takes-enabled", "is-unassigned-takes-enabled", "selected-unassigned-takes", "selected-sidebar-feature-id", "onEntityClicked", "onToggleUnassignedTake", "onMassAppointment"]))
                      : (_ctx.activeTab === _ctx.DW_CONSTANTS.PROBLEMS_TAB.id)
                        ? (_openBlock(), _createBlock(_component_dw_sidebar_problems, {
                            key: 2,
                            entities: _ctx.problems,
                            "is-wait-list-enabled": _ctx.isProblemsWaitListEnabled,
                            "is-downtime-enabled": _ctx.isProblemsDowntimeEnabled,
                            "is-delaying-enabled": _ctx.isProblemsDelayingEnabled,
                            "is-completed-orders-enabled": _ctx.isProblemsCompletedOrdersEnabled,
                            "selected-sidebar-feature-id": _ctx.selectedSidebarFeatureId,
                            onEntityClicked: _ctx.onProblemEntityClicked
                          }, null, 8, ["entities", "is-wait-list-enabled", "is-downtime-enabled", "is-delaying-enabled", "is-completed-orders-enabled", "selected-sidebar-feature-id", "onEntityClicked"]))
                        : _createCommentVNode("", true)
                ], 64))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["vertical-tabs__tab", { 'tab--active': _ctx.activeTab && _ctx.activeTab === _ctx.DW_CONSTANTS.COURIERS_TAB.id }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onTabChange(_ctx.DW_CONSTANTS.COURIERS_TAB.id)))
          }, _hoisted_9, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["vertical-tabs__tab", { 'tab--active': _ctx.activeTab && _ctx.activeTab === _ctx.DW_CONSTANTS.ORDERS_TAB.id }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onTabChange(_ctx.DW_CONSTANTS.ORDERS_TAB.id)))
          }, _hoisted_11, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["vertical-tabs__tab", { 'tab--active': _ctx.activeTab && _ctx.activeTab === _ctx.DW_CONSTANTS.PROBLEMS_TAB.id }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onTabChange(_ctx.DW_CONSTANTS.PROBLEMS_TAB.id)))
          }, _hoisted_13, 2)
        ]))
  ], 2))
}